// src/features/monetize/useMonetizeReport.ts

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { MONETIZE_QUERY_KEYS } from '@/lib/constants/monetize';
import { MonetizeApi } from './MonetizeApi';
import { useMonetizeEligibility } from './useMonetizeEligibility';

// The range arithmetic lives in its own module (no browser globals), so it is unit-tested without the api client.
export { presetRange, type ReportPreset } from './reportRange';

/** The Monetize dashboard for a range of UTC days. */
export function useMonetizeReport(from: string, to: string) {
  const { selectedCId } = useAuth();
  const { eligible } = useMonetizeEligibility();
  const query = useQuery({
    queryKey: MONETIZE_QUERY_KEYS.report(selectedCId ?? 0, from, to),
    queryFn: () => MonetizeApi.getReport(selectedCId!, from, to),
    enabled: eligible && selectedCId != null && !!from && !!to,
    staleTime: 60 * 1000,
  });
  return { report: query.data, isLoading: query.isLoading, isError: query.isError, error: query.error, refetch: query.refetch };
}
